import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetOrganizationUsersResponseBody } from '../OrganizationsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseOrganizationUsersQueryValues = {
  organizationId: string;
};

export const organizationUsersQueryKeyFactory: IQueryKeyFactory<
  IUseOrganizationUsersQueryValues
> = (values) =>
  values && (['organizationUsers', values.organizationId, null] as const);

export const useOrganizationUsersQuery = (
  values?: IUseOrganizationUsersQueryValues,
  options?: UseQueryOptions<IApiGetOrganizationUsersResponseBody, ApiError>,
): UseQueryResult<IApiGetOrganizationUsersResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: organizationUsersQueryKeyFactory(values),
    queryFn: values
      ? () => api.organizations.getUsers(values.organizationId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
